import { atom, useAtom } from 'jotai';
import { VoucherBody } from 'services/api/voucher';

const voucherFormValuesState = atom<Map<string, VoucherBody> | undefined>(undefined);

const useVoucherValues = () => {
  const [voucherFormValues, setVoucherFormValues] = useAtom(voucherFormValuesState);

  const setVoucherFormCache = (storeId: string, formValues: any) => {
    let cache = voucherFormValues;
    if (!cache) {
      cache = new Map();
    }
    cache.set(storeId, formValues);
    setVoucherFormValues(cache);
  };

  const getVoucherFormCache = (storeId: string) => {
    if (voucherFormValues && voucherFormValues.has(storeId)) {
      return voucherFormValues.get(storeId);
    }
    return undefined;
  };

  const clearVoucherFormCache = (storeId: string) => {
    if (voucherFormValues && voucherFormValues.has(storeId)) {
      const newMap = new Map(voucherFormValues);
      newMap.delete(storeId);
      setVoucherFormValues(newMap);
    }
  };

  return {
    getVoucherFormCache,
    setVoucherFormCache,
    clearVoucherFormCache,
  };
};

export default useVoucherValues;
